/**
 * The navigation pane left of the paper, Word's: the document's title and headings; a click
 * puts the caret there.
 */
import { For, Show, createMemo, type JSX } from "solid-js";
import { goTo, headingsOf } from "./commands";
import type { EditorParts } from "./Editor";

/** The navigation pane. */
export function Navigation(props: { parts: EditorParts }): JSX.Element {
  const headings = createMemo(() => {
    props.parts.tick();
    const v = props.parts.view();
    return v ? headingsOf(v.state.doc) : [];
  });
  return (
    <nav class="doc-nav" id="doc-nav" aria-label="Headings">
      <Show when={headings().length} fallback={<p class="muted">Headings show here (Home → Heading 1).</p>}>
        <ul>
          <For each={headings()}>
            {(h) => (
              <li style={{ "padding-left": `${h.level * 10}px` }}>
                <button
                  type="button"
                  class="linklike"
                  data-doc-heading={h.level}
                  onClick={() => {
                    const v = props.parts.view();
                    if (!v) return;
                    goTo(h.pos)(v.state, v.dispatch);
                    v.focus();
                  }}
                >
                  {h.text}
                </button>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </nav>
  );
}
